import { useSafeLocalStorage } from 'src/hooks/use-storage';

export function useIsEnd2EndTest() {
  const safeLocalStorage = useSafeLocalStorage();
  return safeLocalStorage.getItem('PRISMA_E2E_TEST') === 'true';
}
